import { render } from "./LoginView.vue?vue&type=template&id=be21ff32&ts=true"
import script from "./LoginView.vue?vue&type=script&lang=ts"
export * from "./LoginView.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Github\\SmsAdminOnlineApplication\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__